export default {
  lang: 'Русский',
  title: 'Differences Ranch Journey',

  dark_theme: 'Темная тема',

  sign_in: 'Войти',
  sign_up: 'Зарегистрироваться',
  sign_out: 'Выйти',
  recover: 'Восстановить пароль',
  resend: 'Подтвердить E-mail',
  reset: 'Сбросить пароль',

  yes: 'Да',
  no: 'Нет',

  dev: 'Dev версия',
  release: 'Release версия',
  play: 'Играть',

  xlerrors: {
    //
  },

  notifications: {
    check_email: 'Пожалуйста, проверьте вашу почту.',
    password_changed: 'Пароль изменен, теперь вы можете войти.'
  },

  labels: {
    email: 'E-mail',
    password: 'Пароль',
    new_password: 'Новый пароль',
    promo: 'Получать рассылку',
    agree_to: 'Я согласен с',
    agree_to_tos: 'Условиями использования и Политикой конфиденциальности',
    tos: 'Условия использования и Политика конфиденциальности'
  },

  validations: {
    email_required: 'E-mail обязательное поле',
    email_invalid: 'Введите корректный E-mail',

    password_required: 'Пароль обязательное поле',
    password_invalid: 'Пароль должен быть минимум 6 символов',

    agreement_invalid: 'Вы должны принять правила'
  }
}
